import type { ContentMismatch } from "@ext/markdown/core/edit/logic/Prosemirror/from_markdown";
import { MarkdownParseError } from "@ext/markdown/core/edit/logic/Prosemirror/from_markdown";

export type ParsePosition = {
	/** 1-based line of the text handed to the parser — the article body, not the file. */
	line: number;
	/** `nested` — counted from the start of an embedded text, not of the article. */
	origin: "article" | "nested";
	/** `false` — `preParse` changed the line geometry, so the line no longer maps to the source. */
	trustworthy: boolean;
	mismatch?: ContentMismatch;
};

export const isShowable = (position?: ParsePosition): boolean =>
	Boolean(position) && position.origin === "article" && position.trustworthy;

/** Only the ProseMirror stage carries a position; every other stage throws without one. */
export const positionOf = (error: unknown, trustworthy: boolean): ParsePosition => {
	if (!(error instanceof MarkdownParseError) || error.line === null) return undefined;
	return { line: error.line + 1, origin: "article", trustworthy, mismatch: error.mismatch };
};

export const asNested = (position?: ParsePosition): ParsePosition => position && { ...position, origin: "nested" };
